import { useNavigate } from 'react-router-dom';
import ButtonDesigned from '../../../../../components/UI-Elements/Buttons/ButtonDesigned';
import React from 'react';

interface Props {
  isLoading?: boolean;
  title?: string;
  description?: string;
  loadingTitle?: string;
  loadingDescription?: string;
  buttonText?: string;
}

const DEFAULT_TITLE = 'Great!';
const DEFAULT_DESC = 'You order was successfully submitted';
const LOADING_DESC = 'You’ll be redirected shortly';
const LOADING_TITLE = 'Order submitted and being processed';
const BUTTON_TEXT = 'Back to Dashboard';

export const CoCompleteOrder: React.FC<Props> = ({
  isLoading,
  description = DEFAULT_DESC,
  loadingDescription = LOADING_DESC,
  loadingTitle = LOADING_TITLE,
  buttonText = BUTTON_TEXT,
  title = DEFAULT_TITLE,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-full  ">
      <div className="flex flex-1 justify-center flex-wrap space-x-[5rem]">
        <div className=" my-auto text-base text-secondary_text">
          <img
            className="mx-auto aspect-auto w-[5rem] h- mb-[1.5rem] "
            src={`/assets/icons/red/paper-plane.svg`}
            alt=""
          ></img>
          <p className="text-center mb-[0.25rem]">{isLoading ? loadingTitle : title} </p>
          <p className="text-center mb-[1rem]">{isLoading ? loadingDescription : description} </p>
          <div className="flex-1 flex  justify-center">
            <ButtonDesigned
              isFunctionLoading={isLoading}
              disableButton={isLoading}
              style="outline"
              className=""
              onButtonClick={() => {
                navigate('/dashboard');
              }}
            >
              {buttonText}
            </ButtonDesigned>
          </div>
        </div>
      </div>
    </div>
  );
};
